import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {CoreApiService} from "../../../core/service/core-api.service";
import {BasicDataResponseDto, DtoReferFriend, ProfileDto, UserPhotoDto} from "../types/user.types";
import {ApiResponseDto, DtoDeactivateAccount} from "../../../core/interfaces/core.types";
import {EndUserSignatureOverviewDto, SignatureDto} from "../../user-signatures/type/user-signatures.types";
import {  HttpParams } from '@angular/common/http';


@Injectable({ providedIn: 'root' })
export abstract class UserApiService {

  endPoint: string = "mvseu/eu/endUser"

  constructor(
    protected coreApiService: CoreApiService) {
  }

  public updatePhoto(dto: UserPhotoDto): Observable<ApiResponseDto> {
    return this.coreApiService.update(dto,`${this.endPoint}/photo`);
  }

  public createPhoto(dto: UserPhotoDto): Observable<ApiResponseDto> {
    return this.coreApiService.create(dto,`${this.endPoint}/photo`);
  }

  public deletePhoto(): Observable<ApiResponseDto> {
    return this.coreApiService.delete(`${this.endPoint}/photo`);
  }

  public getPhotoBinary(): Observable<string> {
    return this.coreApiService.getDocumentBinary(`${this.endPoint}/photo`);
  }

  public getPhotoBase64(): Observable<UserPhotoDto> {
    return this.coreApiService.get(`${this.endPoint}/photo`);
  }

  public getProfile(): Observable<ProfileDto> {
    return this.coreApiService.get(`${this.endPoint}/profile`);
  }

  public getBasicData(): Observable<BasicDataResponseDto> {
    return this.coreApiService.get(`${this.endPoint}/getBasicData`);
  }


  public deactivate(password: string): Observable<ApiResponseDto> {
    const dto: DtoDeactivateAccount = {
      password: password
    }
    return this.coreApiService.post(dto,`${this.endPoint}/deactivate`);
  }

  public reactivate(): Observable<ApiResponseDto> {
    return this.coreApiService.post(`${this.endPoint}/reactivate`);
  }

  public referFriend(): Observable<DtoReferFriend> {
    return this.coreApiService.get(`${this.endPoint}/referFriend`);
  }

  public getSignatures(): Observable<EndUserSignatureOverviewDto> {
    return this.coreApiService.get(`${this.endPoint}/signatures`);
  }

  public saveSignatures(signatures: EndUserSignatureOverviewDto): Observable<EndUserSignatureOverviewDto> {
    return this.coreApiService.post(signatures,`${this.endPoint}/signatures`);
  }

  public qrUpload(baseUrl: string){
    const params = new HttpParams().set(
      'baseUrl',
      baseUrl
    );
    return this.coreApiService.get(`${this.endPoint}/qrUpload`, {params});
  }

}
